import { revertDeviceModel } from '@/shared/lib';
import _ from 'lodash';
import { createClient } from '@/shared/api';
import type {
  CountCallCenterDevicesQuery,
  CountCallCenterDevicesQueryVariables,
} from '@/shared/api';
import TICKET_COUNT_CLINIC_DEVICES_QUERY from '../queries/ticketCountClinicDevices';

/**
 * Counts the clinic devices matching a filter so the tab badge can be rendered. Deep-clones the filter and rewrites its model to the legacy identifier, queries TICKET_COUNT_CLINIC_DEVICES_QUERY, and throws the first GraphQL error message when no count came back.
 *
 * @param filter - Filter criteria, whose model is converted to its legacy name.
 * @returns Promise resolving to the clinic device count.
 */
const fetchTicketCountClinicDevices = async (
  filter: CountCallCenterDevicesQueryVariables['filter'],
): Promise<CountCallCenterDevicesQuery['countCallCenterDevices']> => {
  const client = createClient();
  const clonedFilter = _.cloneDeep(filter);
  if (!_.isEmpty(clonedFilter)) {
    clonedFilter.model = revertDeviceModel(clonedFilter.model);
  }
  const countCallCenterDevicesResult = await client.query<
    CountCallCenterDevicesQuery,
    CountCallCenterDevicesQueryVariables
  >({
    query: TICKET_COUNT_CLINIC_DEVICES_QUERY,
    variables: {
      filter: clonedFilter,
    },
  });
  const { data, errors } = countCallCenterDevicesResult;
  const { countCallCenterDevices } = data;

  if (_.isNil(countCallCenterDevices) && errors?.length) {
    throw new Error(errors[0].message);
  }

  return countCallCenterDevices;
};

export default fetchTicketCountClinicDevices;
